module.exports = __webpack_public_path__ + "img/mynewsimg2.ae5e5c5a.png";